const JANEIRO = {
  codigo: 1,
  sigla: "Jan",
  descricao: "Janeiro",
};

const FEVEREIRO = {
  codigo: 2,
  sigla: "Fev",
  descricao: "Fevereiro",
};

const MARCO = {
  codigo: 3,
  sigla: "Mar",
  descricao: "Março",
};

const ABRIL = {
  codigo: 4,
  sigla: "Abril",
  descricao: "Abril",
};

const MAIO = {
  codigo: 5,
  sigla: "Mai",
  descricao: "Maio",
};

const JUNHO = {
  codigo: 6,
  sigla: "Jun",
  descricao: "Junho",
};

const JULHO = {
  codigo: 7,
  sigla: "Jul",
  descricao: "Julho",
};

const AGOSTO = {
  codigo: 8,
  sigla: "Ago",
  descricao: "Agosto",
};

const SETEMBRO = {
  codigo: 9,
  sigla: "Set",
  descricao: "Setembro",
};

const OUTUBRO = {
  codigo: 10,
  sigla: "Out",
  descricao: "Outubro",
};

const NOVEMBRO = {
  codigo: 11,
  sigla: "Nov",
  descricao: "Novembro",
};

const DEZEMBRO = {
  codigo: 12,
  sigla: "Dez",
  descricao: "Dezembro",
};

function values() {
  return [JANEIRO, FEVEREIRO, MARCO, ABRIL, MAIO, JUNHO, JULHO, AGOSTO, SETEMBRO, OUTUBRO, NOVEMBRO, DEZEMBRO];
}

const valueOf = codigo => {
  let csSituacao = JANEIRO;
  values().forEach(situacao => {
    if (situacao.codigo === parseInt(codigo, 0)) {
      csSituacao = situacao;
    }
  });

  return csSituacao;
};

export default {
  JANEIRO,
  FEVEREIRO,
  MARCO,
  ABRIL,
  MAIO,
  JUNHO,
  JULHO,
  AGOSTO,
  SETEMBRO,
  OUTUBRO,
  NOVEMBRO,
  DEZEMBRO,
  values,
  valueOf,
};



// WEBPACK FOOTER //
// ./src/constantes/CsMeses.js